import { UserStatusType } from "../user";

export class UserRequest{
    name:string;
	email:string;
	username:string;
	profilesId:number[];
    status: UserStatusType;
}